module.exports = __webpack_public_path__ + "img/Im8.45a2e11a.png";